import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const DeleteBankStdLoans = () => {
    const [bankStdLoan, setbankStdLoan] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedbankStdLoan();
    }, []);

    const fetchDeletedbankStdLoan = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/bankStdLoan/deleted');
            const data = await response.json();
            setbankStdLoan(data);
        } catch (error) {
            console.error('Error fetching deleted Student Loans:', error);
        }
    };

    const handleRestore = async (bankStdLoanId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to restore this student loan?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/bankStdLoan/restore/${bankStdLoanId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setbankStdLoan(bankStdLoan.filter(bankStdLoan => bankStdLoan.id !== bankStdLoanId));
                        Swal.fire({
                            title: "Restored!",
                            text: "The student loan has been restored.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to restore Student Loan');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to restore the student loan.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error restoring Student Loan:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to restore the student loan.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handlePermanentDelete = async (bankStdLoanId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This action cannot be undone. The student loan will be permanently deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete permanently!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/stdLoans/delete/permanent/${bankStdLoanId}`, {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        setbankStdLoan(bankStdLoan.filter(bankStdLoan => bankStdLoan.id !== bankStdLoanId));
                        Swal.fire({
                            title: "Deleted!",
                            text: "The student loan has been permanently deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete Student Loan permanently');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to permanently delete the student loan.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting Student Loan permanently:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to permanently delete the student loan.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter bank student loans based on search term
    const filteredBankStdLoans = bankStdLoan.filter(loan => 
        (loan.bankName && loan.bankName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.stdLoanName && loan.stdLoanName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.phone && loan.phone.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.email && loan.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.location && loan.location.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (

        <div>

            <AdminDashboard />

            <div className='AllViews-admin-course'>

                <div className="search-icon-admin admin-course-search">
                    <h1>DELETE BANK STUDENT LOANS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                <th>Bank Name</th>
                                    <th>Student Loan Name </th>
                                    {/* <th>University Name</th> */}
                                    <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>Location</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredBankStdLoans.map((bankStdLoan) => (
                                    <tr key={bankStdLoan.id}>
                                        <td>{bankStdLoan.bankName}</td>
                                        <td>{bankStdLoan.stdLoanName}</td>
                                        {/* <td>{bankStdLoan.university}</td> */}
                                        <td>{bankStdLoan.phone}</td>
                                        <td>{bankStdLoan.email}</td>
                                        <td>{bankStdLoan.location}</td>
                                        <td>
                                            {bankStdLoan.website ? (
                                                <a href={bankStdLoan.website} target="_blank" rel="noopener noreferrer" id='view-website'>WEBSITE</a>
                                            ) : (
                                                <span style={{ color: '#999' }}>No Website</span>
                                            )}
                                        </td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(bankStdLoan.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(bankStdLoan.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>



        </div>

    )

}

export default DeleteBankStdLoans